// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../shared/font/gteestiprodisplay_bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../shared/font/gteestiprodisplay_light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../shared/images/premium_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GteDisplayExtra";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "GteDisplayLight";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
.advertisementWidjet_body__yoy46 {
  background: linear-gradient(270deg, #282828 0%, #4E4D4D 100%);
  padding: 20px;
  border-radius: 30px;
  margin-top: 40px;
  position: relative;
}
.advertisementWidjet_body__yoy46::before {
  content: "";
  display: block;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center no-repeat;
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  top: 0;
  left: 0;
  z-index: 1000;
}
.advertisementWidjet_body__yoy46 .advertisementWidjet_header__itl8l {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}
.advertisementWidjet_body__yoy46 .advertisementWidjet_header__itl8l span {
  background: #C7FF24;
  padding: 5px 10px;
  border-radius: 30px;
  font-size: 12px;
  text-transform: uppercase;
  font-family: GteDisplayLight;
  color: #000;
}
.advertisementWidjet_body__yoy46 .advertisementWidjet_header__itl8l button {
  background: #C7FF24;
  padding: 10px 10px 5px 10px;
  border-radius: 50%;
}

.advertisementWidjet_wrapper__\\+zEQh {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.advertisementWidjet_wrapper__\\+zEQh h4 {
  font-size: 27px;
  font-family: GteDisplayExtra;
  color: #fff;
}
.advertisementWidjet_wrapper__\\+zEQh p {
  font-size: 12px;
  font-family: GteDisplayLight;
  line-height: 14px;
  color: #fff;
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/advertisementWidjet/advertisementWidjet.module.scss"],"names":[],"mappings":"AACA;EACE,8BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AAAF;AAGA;EACE,8BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AADF;AAIA;EACE,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAFF;AAGE;EACE,WAAA;EACA,cAAA;EACA,oEAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;AADJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AADJ;AAGI;EACE,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,4BAAA;EACA,WAAA;AADN;AAII;EACE,mBAAA;EACA,2BAAA;EACA,kBAAA;AAFN;;AAOA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;AAJF;AAME;EACE,eAAA;EACA,4BAAA;EACA,WAAA;AAJJ;AAOE;EACE,eAAA;EACA,4BAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;AALJ","sourcesContent":["\r\n@font-face {\r\n  font-family: \"GteDisplayExtra\";\r\n  src: url('../../shared/font/gteestiprodisplay_bold.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"GteDisplayLight\";\r\n  src: url('../../shared/font/gteestiprodisplay_light.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n\r\n.body {\r\n  background: linear-gradient(270deg, #282828 0%, #4E4D4D 100%);\r\n  padding: 20px;\r\n  border-radius: 30px;\r\n  margin-top: 40px;\r\n  position: relative;\r\n  &::before {\r\n    content: '';\r\n    display: block;\r\n    background: url(\"../../shared/images/premium_bg.png\") center no-repeat;\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-size: 100% 100%;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 1000;\r\n  }\r\n  .header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-bottom: 15px;\r\n\r\n    span {\r\n      background: #C7FF24;\r\n      padding: 5px 10px;\r\n      border-radius: 30px;\r\n      font-size: 12px;\r\n      text-transform: uppercase;\r\n      font-family: GteDisplayLight;\r\n      color: #000;\r\n    }\r\n\r\n    button {\r\n      background: #C7FF24;\r\n      padding: 10px 10px 5px 10px;\r\n      border-radius: 50%;\r\n    }\r\n  }\r\n}\r\n\r\n.wrapper {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  flex-direction: column;\r\n\r\n  h4 {\r\n    font-size: 27px;\r\n    font-family: GteDisplayExtra;\r\n    color: #fff;\r\n  }\r\n\r\n  p {\r\n    font-size: 12px;\r\n    font-family: GteDisplayLight;\r\n    line-height: 14px;\r\n    color: #fff;\r\n    margin-top: 8px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `advertisementWidjet_body__yoy46`,
	"header": `advertisementWidjet_header__itl8l`,
	"wrapper": `advertisementWidjet_wrapper__+zEQh`
};
export default ___CSS_LOADER_EXPORT___;
